
import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';

import dnaVideo from "../../assets/landing-page/vidoes/DNA V-1.mp4"
// import ex1Video from "../../assets/landing-page/vidoes/example1.mp4"
// import ex2Video from "../../assets/landing-page/vidoes/example2.mp4"
// import ex3Video from "../../assets/landing-page/vidoes/example3.mp4"
import testVideo from  "../../assets/landing-page/vidoes/Demo-Vertical-Video.mp4"
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

interface VideoBoxProps {
  title: string;
  description: string;
  posterUrl: string;
  videoUrls: string[];
}

interface LeftVideoBoxProps {
  title: string;
  description: string;
  posterUrl: string;
  videoUrls: string[];
}

const ex1Video = "example1.webm"
const ex2Video = "example2.webm"
const ex3Video = "example3.webm";
const VideoBox: React.FC<VideoBoxProps> = ({  posterUrl, videoUrls }) => (
  <Box className="mid_sec_vid" sx={{ marginBottom: 2 }} >
      <Box
        component="video"
        sx={{
          width: '100%',
          height: 'auto',
          background: `url(${posterUrl}) no-repeat center center`,
          backgroundSize: 'cover',
          borderRadius: '10px'
        }}
        autoPlay
        loop
        muted
        playsInline
      >
        {videoUrls.map((url) => (
          <source key={url} src={url} type={`video/${url.split('.').pop()}`} />
        ))}
      </Box>
  </Box>
);

const LeftVideoBox: React.FC<LeftVideoBoxProps> = ({  posterUrl, videoUrls }) => (
  <Box className="" sx={{ marginBottom: 0 }} >
      <Box
        component="video"
        sx={{
          width: '100%',
          height: 'auto',
          background: `url(${posterUrl}) no-repeat center center`,
          backgroundSize: 'cover',
          borderRadius: '10px',
          objectFit: 'cover',
          boxShadow: '0px 0px 5px 1px #717171'
        }}
        autoPlay
        loop
        muted
        playsInline
      >
        {videoUrls.map((url) => (
          <source key={url} src={url} type={`video/${url.split('.').pop()}`} />
        ))}
      </Box>
  </Box>
);
export default function GridContent() {


  const [isFixed, setIsFixed] = useState(false);

  const handleScroll = () => {
      const scrollY = window.scrollY || 0;

      // Check if the scroll position exceeds the view height minus 100 pixels
      if (scrollY > window.innerHeight - 100) {
          setIsFixed(true);
      } else {
          setIsFixed(false);
      }
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => {
          window.removeEventListener('scroll', handleScroll);
      };
  }, []);


// For button click shows message
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
// For button click shows message end

  return (
    <Box sx={{ width: "100vw", marginBottom: "%" }}>
      <Grid item xs={12}>
        {/* <ImageMarquee /> */}
      </Grid>
      <Grid
        container
        sx={{ padding: "2% 6%", height: "auto" }}
        className="our_services"
      >
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          sx={{ padding: "0% 2%", height: "auto" }}
        >
          <Box
            sx={{
              position: isFixed ? "relative" : "relative",
              transition: "position 0.3s, top 0.3s",
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontSize: "1.2rem" }}
              className="small_title"
            >
              Our Services
            </Typography>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Typography
                variant="h4"
                sx={{ fontSize: "1.6rem", padding: "5px 0" }}
                className="title"
              >
                Patient Education
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem" }}
                className="content"
              >
                <b>Simplified Communication :</b> Medical concepts can often be
                hard to explain in words. 3D animations can break down complex
                processes, like how a disease affects the body, or how a
                treatment works, into easily understandable visuals.
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem" }}
                className="content"
              >
                <b>Enhanced Patient Engagement :</b> Visual learning is
                powerful. When patients see a 3D animation of what’s happening
                inside their body, they are more likely to stay engaged and
                retain information compared to standard brochures or verbal
                explanations.
              </Typography>
              <Box sx={{ paddingTop: 3 }}>
                <LeftVideoBox
                  title="Pharmaceutical Animation"
                  description="3D medical animation to Convey Therapeutics, Disease States and Medical Device Training."
                  posterUrl=""
                  videoUrls={[VISUALIZE__URL + ex1Video]}
                />
              </Box>
              <Box mt={1} sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={handleClick}
                  sx={{
                    backgroundColor: "#039ad1",
                    border: "1px solid #0cbeff",
                    color: "#fff",
                    fontWeight: "600",
                    "&:hover": {
                      backgroundColor: "transparent",
                      border: "1px solid #000",
                      color: "#000",
                    },
                  }}
                >
                  Learn More
                </Button>
                <Snackbar
                  open={open}
                  autoHideDuration={3000}
                  onClose={handleClose}
                >
                  <Alert
                    onClose={handleClose}
                    severity="info"
                    variant="filled"
                    sx={{
                      width: "100%",
                      background: "#039ad1",
                      border: "1px solid #64d6ff",
                    }}
                  >
                    We are working on this !!!
                  </Alert>
                </Snackbar>
              </Box>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} pt={4}>
              <Typography
                variant="h4"
                sx={{ fontSize: "1.6rem", padding: "5px 0" }}
                className="title"
              >
                Medical Professional Training
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem" }}
                className="content"
              >
                <b>Detailed Visualization :</b> Animations can vividly depict
                human anatomy, surgical procedures, and physiological processes
                in ways that are impossible with traditional textbooks or static
                images. Medical professionals can explore the intricacies of the
                human body, such as organ structures or cellular processes, in
                dynamic, interactive ways.
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem" }}
                className="content"
              >
                <b>Training for Rare or Complex Cases :</b> Certain medical
                cases or conditions might be too rare for trainees to encounter
                regularly. 3D animations can replicate these complex or unusual
                cases, allowing professionals to be prepared for them when they
                do occur.
              </Typography>
              <Box sx={{ paddingTop: 3 }}>
                <LeftVideoBox
                  title="Pharmaceutical Animation"
                  description="3D medical animation to Convey Therapeutics, Disease States and Medical Device Training."
                  posterUrl=""
                  videoUrls={[VISUALIZE__URL + ex2Video]}
                />
              </Box>
              <Box mt={1} sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={handleClick}
                  component="a"
                  // href="/"
                  variant="contained"
                  className=""
                  sx={{
                    backgroundColor: "#039ad1",
                    border: "1px solid #0cbeff",
                    fontWeight: "600",
                    "&:hover": {
                      backgroundColor: "transparent",
                      border: "1px solid #000",
                      color: "#000",
                    },
                  }}
                >
                  Learn More
                </Button>
                <Snackbar
                  open={open}
                  autoHideDuration={3000}
                  onClose={handleClose}
                >
                  <Alert
                    onClose={handleClose}
                    severity="info"
                    variant="filled"
                    sx={{
                      width: "100%",
                      background: "#039ad1",
                      border: "1px solid #64d6ff",
                    }}
                  >
                    We are working on this !!!
                  </Alert>
                </Snackbar>
              </Box>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} pt={4}>
              <Typography
                variant="h4"
                sx={{ fontSize: "1.6rem", padding: "5px 0" }}
                className="title"
              >
                Pharmaceutical Marketing
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem" }}
                className="content"
              >
                <b>Clear Communication of Complex Concepts :</b> Drug mechanisms
                can be challenging to explain, especially when they involve
                intricate biochemical pathways. 3D animations can simplify these
                concepts by visually representing how the drug interacts with
                the body at a molecular or cellular level, making it easier or
                healthcare providers to understand and convey to patients.{" "}
              </Typography>
              <Box sx={{ paddingTop: 3 }}>
                <LeftVideoBox
                  title="Pharmaceutical Animation"
                  description="3D medical animation to Convey Therapeutics, Disease States and Medical Device Training."
                  posterUrl=""
                  videoUrls={[VISUALIZE__URL + ex3Video]}
                />
              </Box>
              <Box mt={1} sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={handleClick}
                  component="a"
                  // href="/"
                  variant="contained"
                  className=""
                  sx={{
                    backgroundColor: "#039ad1",
                    border: "1px solid #0cbeff",
                    fontWeight: "600",
                    "&:hover": {
                      backgroundColor: "transparent",
                      border: "1px solid #000",
                      color: "#000",
                    },
                  }}
                >
                  Learn More
                </Button>
                <Snackbar
                  open={open}
                  autoHideDuration={3000}
                  onClose={handleClose}
                >
                  <Alert
                    onClose={handleClose}
                    severity="info"
                    variant="filled"
                    sx={{
                      width: "100%",
                      background: "#039ad1",
                      border: "1px solid #64d6ff",
                    }}
                  >
                    We are working on this !!!
                  </Alert>
                </Snackbar>
              </Box>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} pt={4}>
              <Typography
                variant="h4"
                sx={{ fontSize: "1.6rem", padding: "5px 0" }}
                className="title"
              >
                Clear Visualization of Device Functionality
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem" }}
                className="content"
              >
                <b>Explaining Complex Mechanisms :</b> Many medical devices,
                especially advanced surgical tools or diagnostic equipment,
                involve complex mechanisms. Through 3D animations and
                interactive models, the functionality can be visualized in
                real-time, allowing users to see exactly how the device works
                inside the body or in a clinical environment.
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem" }}
                className="content"
              >
                <b>Step-by-Step Demonstrations :</b> Animations can break down
                the usage of the device step-by-step, from setup and operation
                to cleaning and maintenance. This helps users, both healthcare
                professionals and technicians, understand how to use the device
                effectively.
              </Typography>
              <Box sx={{ paddingTop: 3 }}>
                <LeftVideoBox
                  title="Pharmaceutical Animation"
                  description="3D medical animation to Convey Therapeutics, Disease States and Medical Device Training."
                  posterUrl=""
                  videoUrls={[dnaVideo]}
                />
              </Box>
              <Box mt={1} sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={handleClick}
                  component="a"
                  // href="/"
                  variant="contained"
                  className=""
                  sx={{
                    backgroundColor: "#039ad1",
                    border: "1px solid #0cbeff",
                    fontWeight: "600",
                    "&:hover": {
                      backgroundColor: "transparent",
                      border: "1px solid #000",
                      color: "#000",
                    },
                  }}
                >
                  Learn More
                </Button>
                <Snackbar
                  open={open}
                  autoHideDuration={3000}
                  onClose={handleClose}
                >
                  <Alert
                    onClose={handleClose}
                    severity="info"
                    variant="filled"
                    sx={{
                      width: "100%",
                      background: "#039ad1",
                      border: "1px solid #64d6ff",
                    }}
                  >
                    We are working on this !!!
                  </Alert>
                </Snackbar>
              </Box>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} pt={4} pb={8}>
              <Typography
                variant="h4"
                sx={{ fontSize: "1.6rem", padding: "5px 0" }}
                className="title"
              >
                Simplifying Complex Scientific Concepts
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem" }}
                className="content"
              >
                <b>Turning Data into Visual Insights :</b> Scientific research
                often involves complex datasets, processes, or mechanisms that
                are difficult to explain using text alone. Visual content like
                infographics, charts, 3D animations, and simulations can
                transform raw data into comprehensible, engaging visuals. For
                example, the interaction between molecules or the dynamics of a
                biological system can be effectively illustrated through
                animations. <br></br>Researchers can use animations to
                illustrate concepts like quantum mechanics, protein folding, or
                cellular processes, making these ideas easier to grasp.
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem" }}
                className="content"
              >
                <b>Engaging Stakeholders and Peer :</b> Whether it's a
                scientific conference or an internal R&D presentation, visuals
                can captivate the audience and make complex research accessible.
                Compelling animations and interactive visuals break down complex
                findings into digestible pieces, ensuring key points are
                understood by specialists and non-specialists alike.
              </Typography>
              <Box sx={{ paddingTop: 3 }}>
                <LeftVideoBox
                  title="Pharmaceutical Animation"
                  description="3D medical animation to Convey Therapeutics, Disease States and Medical Device Training."
                  posterUrl=""
                  videoUrls={[dnaVideo]}
                />
              </Box>
              <Box mt={1} sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={handleClick}
                  component="a"
                  // href="/"
                  variant="contained"
                  className=""
                  sx={{
                    backgroundColor: "#039ad1",
                    border: "1px solid #0cbeff",
                    fontWeight: "600",
                    "&:hover": {
                      backgroundColor: "transparent",
                      border: "1px solid #000",
                      color: "#000",
                    },
                  }}
                >
                  Learn More
                </Button>
                <Snackbar
                  open={open}
                  autoHideDuration={3000}
                  onClose={handleClose}
                >
                  <Alert
                    onClose={handleClose}
                    severity="info"
                    variant="filled"
                    sx={{
                      width: "100%",
                      background: "#039ad1",
                      border: "1px solid #64d6ff",
                    }}
                  >
                    We are working on this !!!
                  </Alert>
                </Snackbar>
              </Box>
            </Grid>
          </Box>
        </Grid>
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          sx={{ padding: "0% 2%" }}
          className="fix_video"
          id="target-element"
        >
          <Box
            sx={{
              position: isFixed ? "sticky" : "relative",
              top: isFixed ? "10px" : "initial", // Adjust as necessary
              transition: "position 0.3s, top 0.3s",
            }}
          >
            <VideoBox
              title="Pharmaceutical Animation"
              description="3D medical animation to Convey Therapeutics, Disease States and Medical Device Training."
              posterUrl=""
              videoUrls={[testVideo]}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ padding: "5% 6%", backgroundColor: "#efefef" }}
        className="team"
      >
        <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="our_team"
          sx={{
            textAlign: "center",
            margin: "0 auto",
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontSize: "1.6rem", padding: "5px 0" }}
            className="title"
          >
            Our Team
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "1.3rem", marginTop: "5px" }}
            className="content"
          >
            Our team is composed of skilled medical illustrators, animators, and
            subject matter experts who are passionate about science and art.
            With backgrounds in medicine, biology, and digital media, we bring a
            unique blend of expertise to every project, ensuring accuracy and
            creativity in equal measure
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

